jQuery(function( $ ) {
	'use strict'

	// Create a Vue directive that lets us sort the tabs using sortable.js
	Vue.directive('sortable', {
		inserted: function (el, binding) {
			var sortable = new Sortable(el, binding.value );
		}
	});

	const locallyStoredDataFieldNames = [
		'clientList',
		'priceList',
		'testList',
		'testMethodLimitsMap',
		'importParameterTranslationMap',
		'testComboList',
		'sampleList',
		'outlierStandardDeviationRatio',

		// dropdowns
		'collectionMethodOptions',
		'deliveryModeOptions' ,
		'jobStatusOptions',
		'locationOptions',
		'matrixOptions',
		'preservedByOptions',
		'sampledByOptions',
		'unitsOptions',
		'analyteOptions',
	];

	window.vmLoader = new Vue({
		el: '#v-loader',
		store, // using vuex store
		data: {
			loadFailureMessage: '',

			locallyStoredDataFields: locallyStoredDataFieldNames,

			javascriptInitMethodCounter: 0,

			username: null,
			password: null,

		},
		beforeCreate: function(){
			locallyStoredDataFieldNames.forEach( field => {
				this.$options.computed[ field + 'Loaded' ] = () => store.state[ field + 'Loaded' ];
				this.$options.computed[ field + 'Count' ]  = () => store.state[ field ].length;
			} );
		},
		mounted: function() {
			/* Load all of the major data pieces from local storage or ajax into the store and then
			show the page - it will just be a loading screen up until that point with a log of what
			is loaded and ready... */

			vmNotificationManager.hideNotifications();
			//this.loadAllLocallyStoredData();
		},

		methods: {
			signin() {
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'sign_in',
						username: _this.username,
						password: _this.password,
					},
					onSuccess( data ) {
						_this.password = null;
						console.log('signed in', data)
						window.vmHeader.username = data.username;
						document.getElementById('nav_username').innerText = data.username;
						$('#sign-in-form').hide();
						$('#loading-summary').show();
						$('#loading-check-list').show();
						$('#loading-fallback-action').show();
						_this.loadAllLocallyStoredData();
					},
					onError() {
					},
				});
			},

			loadAllLocallyStoredData: function() {
				for ( let i = 0; i < this.locallyStoredDataFields.length; i++ ) {
					setTimeout(
						() => LocalStorageManager.updateField( this.locallyStoredDataFields[i] ),
						i * 20
					);
				}
			},

			// Helper used to populate datalists for inputs with js to act like comboboxes
			populateDatalist: function( id, optionsFieldName, propertyName = null ) {
				const datalist = $( '#datalist-' + id );
				const options = LocalStorageManager.get( optionsFieldName );

				_.forEach( options, function( value ) {
					const option = document.createElement( 'option' );
					option.value = value === null || value === undefined
						? null
						: propertyName
						? value[ propertyName ]
						: value;
					datalist.append( option );
				});
				// Returns true so it can be used as a promise
				return true;
			},

			callJavascriptInitFunctions: function() {

				vmLoader.populateDatalist( 'units', 'unitsOptions' );

				vmLoader.populateDatalist( 'analytes', 'analyteOptions' );

				vmLoader.populateDatalist( 'tests', 'testList', 'testName' );

				vmLoader.populateDatalist( 'samples', 'sampleList' );

				vmLoader.populateDatalist( 'projects', 'projectList' );

			},

			initSucceeded: function() {

				// Show the application, show new ajax messages
				window.vmNotificationManager.showNotifications();

				this.hide();
			},

			hide: function() {
				$( '.loading-screen' ).fadeOut(200);
				AppTabs.showTab( window.location.hash.substring(1) || 'dashboard' );
			},

			refreshLocallyStoredData: function() {
				console.log( 'refresh locally stored data' );
				LocalStorageManager.clear();
				window.vmLoader.loadAllLocallyStoredData();
			},
		},

		computed: {
			numFields: function() {
				return this.locallyStoredDataFields.length;
			},

			numValidatedFields: function() {
				const _this = this,
					fields = this.locallyStoredDataFields,
					validatedFields = fields.filter( x => _this[ x + 'Loaded' ] );

				return validatedFields.length;
			},

			loadingProgress: function() {
			 	return ( this.numValidatedFields )
					/ ( this.numFields )
					* 100;
			},
		},

		watch: {
			numValidatedFields: function( currentCount ) {
				if ( currentCount == this.numFields ) {
					this.callJavascriptInitFunctions();
				}
			},
			loadingProgress: function( currentProgress ) {
				if ( currentProgress == 100 ) {
					this.initSucceeded();
				}
			},
		},
	});


	window.vmHeader = new Vue({
		el: '#v-header',
		created: function() {
			vmNotificationManager.addInfoNotification( 'vmHeader Initialized' );
		},
		mounted: function() {
			this.connectNotificationsSocket();
			AppTabs.mount( this, document.getElementById( 'content' ) );
			document.body.style.overflowY = 'hidden';
			document.getElementById('content').style.height = window.innerHeight - document.getElementById('v-header').offsetHeight + 'px';
			window.addEventListener("resize", e => {
				document.getElementById('content').style.height = window.innerHeight - document.getElementById('v-header').offsetHeight + 'px';
				const embedToolbarTop = document.getElementById('v-header').offsetHeight + 'px';
				const embedToolbars = document.getElementsByClassName('embed-toolbar');
				for (let i = 0; i < embedToolbars.length; ++i )
					embedToolbars[i].style.top = embedToolbarTop;
			});
		},
		data: {
			notificationsSocketStatus: 'disconnected',
			openTabs: [],
			activeTab: null,
			username: null,
		},

		computed: {
			isDisconnected() {
				return 'Connected' != this.notificationsSocketStatus;
			},
			notificationsSocketStatusString() {
				return 'Notifications Socket Status: ' + this.notificationsSocketStatus;
			}
		},


		methods: {
			connectNotificationsSocket() {
				if ( this.notificationsSocketStatus == 'connected' ) {
					InfoModalManager.show( { message: 'You are already connected to the Notifications Socket.' });
				} else {
					window.connectNotificationsSocket();
				}
			},
			setNotificationsSocketStatus( status ) {
				this.notificationsSocketStatus = status;
			},
			// called by sortable.js
			reorderOpenTabs: function( { oldIndex, newIndex } ) {
				const movedItem = this.openTabs.splice( oldIndex, 1 )[0];
				this.openTabs.splice( newIndex, 0, movedItem );
			},
			// Refresh the page so DataTables will be full width
			redraw: function() {
				setTimeout( function() {
					$( window ).trigger( 'resize' );
				}, 10 );
			},
			refreshLocallyStoredData: function() {
				console.log( 'refresh locally stored data' );
				LocalStorageManager.clear();
				window.vmLoader.loadAllLocallyStoredData();
			},
			signout(event) {
				if ( this.username === null )
					return;

				console.log(event);
				window.ajaxCall({
					data : {
						action: 'end_session',
					},
					onSuccess( data ) {
						console.log( data );
						//if (event === undefined || event === null)
						location.reload();
					},
					onError() {
					},
				});
			},
		},
	});

	window.addEventListener("beforeunload", window.vmHeader.signout, false);

});
